  //Variables que se comparten entre diferentes componentes usando zustand
import { create } from "zustand";

export const useUsuarioStore = create((set) => ({

  cerrarModal: false,
  setCerrarModal: (valor) => set({ cerrarModal: valor}),
  adquiriente: [],

  boolElemento: false, 
  setBoolElemento: (valor) => set({ boolElemento: valor}), 
  boolAdquiriente: false,
  setBoolAdquiriente: (valor) => set({ boolAdquiriente: valor }),
  setAdquiriente: (nuevosAdquirientes) =>
    set({ adquiriente: nuevosAdquirientes }),
  deleteAdquiriente: () => set({ adquiriente: [] }),
  agregarAdquiriente: (nuevo) =>
    set((state) => {
      // Crear copia del objeto
      const nuevoObj = { ...nuevo };

      // Si existe 'elnombre', lo renombramos a 'nombre'
      if (nuevoObj.elnombre) {
        nuevoObj.nombre = nuevoObj.elnombre;
        nuevoObj.ap_materno = nuevoObj.elap_materno;
        nuevoObj.ap_paterno = nuevoObj.elap_paterno;
        delete nuevoObj.elnombre;
        delete nuevoObj.elap_materno;
        delete nuevoObj.elap_paterno;
      }

      if (nuevoObj.elrazon_social) {
        nuevoObj.razon_social = nuevoObj.elrazon_social;
        delete nuevoObj.elrazon_social;
      }

      return { adquiriente: [...state.adquiriente, nuevoObj] };
    }),

  otorgante: [],
  boolOtorgante: false,
  setBoolOtorgante: (valor) => set({ boolOtorgante: valor }),
  setOtorgante: (nuevosOtorgantes) => set({ otorgante: nuevosOtorgantes }),
  deleteOtorgante: () => set({ otorgante: [] }),
  agregarOtorgante: (nuevo) =>
    set((state) => {
      const nuevoObj = { ...nuevo };

      if (nuevoObj.elnombre) {
        nuevoObj.nombre = nuevoObj.elnombre;
        nuevoObj.ap_materno = nuevoObj.elap_materno;
        nuevoObj.ap_paterno = nuevoObj.elap_paterno;
        delete nuevoObj.elnombre;
        delete nuevoObj.elap_materno;
        delete nuevoObj.elap_paterno;
      }

      if (nuevoObj.elrazon_social) {
        nuevoObj.razon_social = nuevoObj.elrazon_social;
        delete nuevoObj.elrazon_social;
      }

      return { otorgante: [...state.otorgante, nuevoObj] };
    }),

    documentosGuardados:[],
    deleteDocumentosGuardados:() => set({ documentosGuardados: [] }),


  agregarOActualizarDocumentos: (nuevo) =>
    set((state) => {
      const nuevoHecho = nuevo[1]; // el segundo elemento: el hecho jurídico

      // Buscar si ya existe un grupo con el mismo hecho jurídico
      const existe = state.documentosGuardados.find(
        (doc) => doc[1] === nuevoHecho
      );

      // Si existe, reemplazarlo; si no, agregarlo
      const nuevosDocumentos = existe
        ? state.documentosGuardados.map((doc) =>
            doc[1] === nuevoHecho ? nuevo : doc
          )
        : [...state.documentosGuardados, nuevo];

      return { documentosGuardados: nuevosDocumentos };
    })


}));
